import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M3.862 6.468L1.86 4.466c-.26-.26-1.005-.364-1.265 0-.26.365-.26 1.009 0 1.269l2.793 2.793c.26.26.68.26.94 0l7.067-7.06c.26-.26.26-.925 0-1.268-.26-.343-1.062-.194-1.322.066L3.862 6.468z"
      transform="translate(6 7.5)"
      fill={fill}
    />
  </g>
);

export default Icon;
